import React from 'react';
import { Button, ButtonPriority } from 'wix-ui-tpa';
import { Tooltip } from '@wix/ricos';

const ActionButton = ({
  text,
  tooltipText = '',
  onClick,
  isDisabled,
  dataHook,
  secondary,
}: {
  text: string;
  tooltipText?: string;
  onClick: () => any;
  isDisabled?: boolean;
  secondary?: boolean;
  dataHook?: string;
}) => {
  let priority;
  if (isDisabled) {
    priority = ButtonPriority.basicSecondary;
  } else if (secondary) {
    priority = ButtonPriority.secondary;
  } else {
    priority = ButtonPriority.primary;
  }

  const button = (
    <Button
      upgrade
      priority={priority}
      // className={st(classes.actionButton, {}, styles.publishButton)}
      type="button"
      data-hook={dataHook}
      onClick={onClick}
    >
      {text}
    </Button>
  );

  return tooltipText ? (
    <Tooltip content={tooltipText}>{button}</Tooltip>
  ) : (
    button
  );
};

export default ActionButton;
